import { useEffect, useMemo, useState } from "react";

/**
 * Paginação no navegador, para listas que o servidor já devolve inteiras.
 *
 * As listas pesadas (Inscritos e Financeiro) paginam no servidor, porque a consulta é cara.
 * As demais são pequenas o bastante para virem de uma vez — aqui o problema é só a tela,
 * que fica lenta e difícil de ler com centenas de linhas de uma vez.
 *
 * `itens` deve ser a lista JÁ filtrada: assim a contagem e as páginas acompanham o filtro.
 * Ao mudar o tamanho da lista (novo filtro, nova busca), volta para a primeira página —
 * sem isso a tela abriria vazia numa página que não existe mais.
 */
export function usePaginacao(itens, porPaginaInicial = 25) {
  const [pagina, setPagina] = useState(0);
  const [porPagina, setPorPagina] = useState(porPaginaInicial);

  const total = itens?.length || 0;

  useEffect(() => { setPagina(0); }, [total]);

  const visiveis = useMemo(
    () => (itens || []).slice(pagina * porPagina, pagina * porPagina + porPagina),
    [itens, pagina, porPagina]
  );

  return {
    visiveis,
    total,
    // Pronto para espalhar no <TablePagination {...props} />
    props: {
      component: "div",
      count: total,
      page: pagina,
      onPageChange: (_, p) => setPagina(p),
      rowsPerPage: porPagina,
      onRowsPerPageChange: (e) => { setPorPagina(Number(e.target.value)); setPagina(0); },
      rowsPerPageOptions: [25, 50, 100, 200],
      labelRowsPerPage: "Por página:",
      labelDisplayedRows: ({ from, to, count }) => `${from}–${to} de ${count}`,
    },
  };
}
